import * as React from "react";
import {Component} from "react";
import WeatherCondition from "./WeatherCondition";

interface IWeatherRealtimeProps {
    data: any;
    unitType: string;
}

class WeatherRealtime extends Component<IWeatherRealtimeProps, {}> {
    public render() {
        const data = this.props.data;

        return (
            <React.Fragment>
                <WeatherCondition data={data} unitType={this.props.unitType}/>
                {
                    this.props.unitType === 'celsius' ? <React.Fragment>
                        <div>
                            {"Feels Like: "}<b>{data.feelslike_c}</b><sup>&#176;{"C"}</sup>
                        </div>
                        <div>
                            {"Wind Direction: "}<b>{data.wind_dir}</b>
                        </div>
                        <div>
                            {"Wind Speed: "}<b>{data.wind_kph}</b>{" km/h"}
                        </div>
                    </React.Fragment> : <React.Fragment>
                        <div>
                            {"Feels Like: "}<b>{data.feelslike_f}</b><sup>&#176;{"F"}</sup>
                        </div>
                        <div>
                            {"Wind Direction: "}<b>{data.wind_dir}</b>
                        </div>
                        <div>
                            {"Wind Speed: "}<b>{data.wind_mph}</b>{" mph"}
                        </div>
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }

}

export default WeatherRealtime;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/Weather/WeatherRealtime.tsx